import React from 'react';
import { withStyles } from '@mui/styles';
import clsx from "clsx";

const styles = theme => ({
  root: {
    border: 'none !important',
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    padding: '5px 0',
    fontSize: '0.8568rem',
    width: '100%',
    boxSizing: 'border-box',
    '&:hover': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.87)',
    },
    '&:focus': {
      outline: 'none !important',
      borderBottom: '2px solid rgb(19, 118, 157) !important',
    },
  },
  error: {
    background: 'rgba(255, 0, 0, 0.2)',
    borderBottom: '2px solid red !important',
  }
});

const SimpleInput = props => {
  const { classes, sidebarMode, style } = props;

  return (
    <input
      placeholder={props.placeholder}
      className={clsx({
        [classes.root]: !sidebarMode,
        [style?.sidebarInput]: sidebarMode,
        [classes.error]: props.error,
      })}
      onChange={props.handleInputs}
      onKeyDown={props.onKeyDown}
      name={props.inputId}
      value={props.value}
    />
  );
}

SimpleInput.defaultProps = {
  onKeyDown: () => {},
}

export default withStyles(styles)(SimpleInput);